/**
 * author: Soumya Shreyas
 */
import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { BsFillSquareFill } from "react-icons/bs";
const SupplierInfoTab = ({ t, profiledata }) => {
  return (
    <div className="p-2">
      <div className="card SPP_Card02">
        <div className="row m-0 px-3 py-2">
          <div className="col-lg-3 p-2">
            <p className="m-0">{t("RiskCategory.label")}</p>
            <h6 className="m-0">
              {profiledata && profiledata?.riskCategory?.resultType != null && (
                <span
                  style={{
                    color: profiledata?.riskCategory?.colorCode,
                  }}
                >
                  {profiledata?.riskCategory?.resultType}
                </span>
              )}
            </h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("RiskRating.label")}</p>
            <h6>
              {profiledata?.weightedScore
                ? profiledata.weightedScore + "/10"
                : "-"}
            </h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("CreatedOn.label")}</p>
            <h6>
              {moment(profiledata?.supplierProfile?.onboardedDate).format(
                "MMM DD, YYYY"
              )}
            </h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("RegistrationId.label")}</p>
            <h6>{profiledata?.supplier?.regNumber}</h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("SupplierType.label")}</p>
            <h6>{profiledata?.supplierProfile?.supplierType?.name}</h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("CountryofOperation.label")}</p>
            <ul className="Country_oper_box">
              <li>
                <BsFillSquareFill className="text-green" />{" "}
                <h6>{profiledata?.supplier?.operationalCountry?.name}</h6>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("ProductionCountries.label")}</p>
            {/* <ul className="Country_oper_box">
              <li>
                <BsFillSquareFill className="text-red" /> <h6>Ukraine</h6>
              </li>
              <li>
                <BsFillSquareFill className="text-orange" /> <h6>Pakistan</h6>
              </li>
            </ul> */}
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("InternationalBranches.label")}</p>
            <ul className="Country_oper_box">
              {profiledata?.internationalBranches?.map((item) => (
                <li key={item.id}>
                  <h6>{item.name}</h6>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="row m-0 border-top px-3 py-2">
          <div className="col-lg-12 p-2">
            <h5>{t("SuppliedMaterials.label")}</h5>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("NoofMaterialsSupplied.label")}</p>
            <h6>75/100</h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("NoofRiskyMaterials.label")}</p>
            <ul className="Country_oper_box">
              <li>
                <BsFillSquareFill className="text-Critical" /> <h6>100</h6>
              </li>
              <li>
                <BsFillSquareFill className="text-High" /> <h6>123</h6>
              </li>
            </ul>
          </div>
        </div>

        <div className="row m-0 border-top px-3 py-2">
          <div className="col-lg-12 p-2">
            <h5>{t("Employees.label")}</h5>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("EmployeeStrength.label")}</p>
            <h6>254</h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("MigrantWorkers.label")}</p>
            <h6>Yes</h6>
          </div>
          <div className="col-lg-3 p-2">
            <p>{t("WorkersfromHighRiskCountries.label")}</p>
            <h6>Yes</h6>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(SupplierInfoTab);
